import { User } from '../pages/UserProfile/userProfileSlice';

export default function mapExistingUserInWorkflowStep(
  projectApprovalWorkflowSteps: {
    id: number;
    userId: number;
  }[],
  users: User[]
) {
  const existingUsers = [];
  for (let i = 0; i < projectApprovalWorkflowSteps.length; i++) {
    const projectApprovalWorkflowStep = projectApprovalWorkflowSteps[i];
    const user = users.find(
      (user) => user.id === projectApprovalWorkflowStep.userId
    );
    if (user) existingUsers.push(user);
  }
  return existingUsers;
}
